import Service from '@ember/service';
import { inject as service } from '@ember/service';
import config from 'ui-ember-vite/config/environment';

export default class RequestService extends Service {
  @service session;
  @service errorHandler;
  // @service toast;

  async fetch(uri, options = {}, handleErrors = true) {
    let { token } = this.session.get('data.authenticated');
    let requestOptions = { ...options };

    if (!requestOptions.headers) {
      requestOptions.headers = {};
    }

    if (!requestOptions.anonymous) {
      requestOptions.headers = Object.assign(requestOptions.headers, {
        Authorization: `Bearer ${token}`,
      });
    }

    let url = this._buildUrl(uri);

    return fetch(url, requestOptions)
      .then(this._handleResponse.bind(this))
      .catch((error) => {
        if (!handleErrors) {
          throw error;
        }

        this.errorHandler.handleBackendErrors(error);
      });
  }

  _buildUrl(uri) {
    let { host, namespace } = config.API;

    if (host) {
      // Si hay HOST configurado en .env
      return `${host}/${namespace}/${uri}`;
    } else {
      // Si no hay HOST conf local
      return `/${namespace}/${uri}`;
    }
  }

  _handleResponse(response) {
    if (response.ok) {
      let contentType = response.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        return response.json();
      }

      return response;
    }

    if (this._isBadRequestResponse(response)) {
      // this.toast.error('Solicitud incorrecta.');
    } else if (this._isUnauthorizedResponse(response)) {
      // this.toast.error('Esta operación requiere de autenticación.');
    } else if (this._isForbiddenResponse(response)) {
      // this.toast.error('No tiene permiso para realizar esta operación.');
    } else if (this._isNotFoundResponse(response)) {
      // this.toast.error('Registro no encontrado.');
    } else if (this._isInvalidResponse(response)) {
      // this.toast.error('Hay un error de validación.');
    } else if (this._isServerErrorResponse(response)) {
      // this.toast.error('Ha ocurrido un error no esperado.');
    } else {
      // this.toast.error('Ocurrió un error con su solicitud.');
    }

    throw response;
  }

  _isBadRequestResponse(response) {
    return response.status === 400;
  }

  _isUnauthorizedResponse(response) {
    return response.status === 401;
  }

  _isForbiddenResponse(response) {
    return response.status === 403;
  }

  _isNotFoundResponse(response) {
    return response.status === 404;
  }

  _isInvalidResponse(response) {
    return response.status === 422;
  }

  _isServerErrorResponse(response) {
    return response.status >= 500;
  }

  async post(uri, data = {}, options = {}, handleErrors = true) {
    let requestOptions = Object.assign(
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
      options,
    );

    return this.fetch(uri, requestOptions, handleErrors);
  }
}